import { yupResolver } from '@hookform/resolvers/yup'
import { Download, Publish } from '@mui/icons-material'
import { Button, Link } from '@mui/material'
import { subMonths } from 'date-fns'
import { useConfirm } from 'material-ui-confirm'
import React, { FunctionComponent } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import SimpleContainer from '../../../../base/components/Container/SimpleContainer'
import StackMenu from '../../../../base/components/MyMenu/StackMenu'
import Breadcrumb from '../../../../base/components/Template/Breadcrumb/Breadcrumb'
import { getDateListAnio, getDateListMes } from '../../../../services/fechas'
import { notError } from '../../../../utils/notification'
import { swalAsyncConfirmDialog, swalException } from '../../../../utils/swal'
import { apiRecepcionArchivoMasivo } from '../../api/recepcionArchivoMasivo.api'
import EmisionMasivaForm from '../../components/abm/EmisionMasivaForm'
import { EmisionMasivaInputProps } from '../../interfaces/emisionMasiva.interface'
import { EmisionMasivaRegistroComposeService } from '../../services/emisionMasivaRegistroComposeService'
import { swalEnvioMasivo } from '../../services/swalEnvioMasivo'
import { plantillaImportacionMasiva } from '../../utils/enlaces'
import {
  emisionMasivaValidator,
  EmisionMasivaValidatorSchema,
} from '../../validator/emisionMasivaValidator'
import { ventasRoutesMap } from '../../VentasRoutesMap'

interface OwnProps {}

type Props = OwnProps

const EmisionMasiva: FunctionComponent<Props> = (props) => {
  const form = useForm<EmisionMasivaInputProps>({
    defaultValues: {
      gestion: getDateListAnio(new Date()),
      mes: getDateListMes(subMonths(new Date(), 1)),
    },
    resolver: yupResolver<any, any, any>(EmisionMasivaValidatorSchema),
  })

  /**
   * Confirmamos la recepcion del archivo
   * @param values
   */
  const onSubmit: SubmitHandler<EmisionMasivaInputProps> = async (values) => {
    const val = await emisionMasivaValidator(values)
    if (val.length > 0) {
      notError(val.join('<br>'))
      return
    }

    const apiInput = EmisionMasivaRegistroComposeService(values)
    await swalAsyncConfirmDialog({
      preConfirm: async () => {
        const resp: any = await apiRecepcionArchivoMasivo(
          apiInput.input,
          apiInput.archivo,
        ).catch((e) => ({
          error: e,
        }))
        if (resp.error) {
          swalException(resp.error)
          return false
        }
        return resp
      },
    }).then((resp) => {
      if (resp.isConfirmed) {
        swalEnvioMasivo(resp.value)
      }
      if (resp.isDenied) {
        swalException(resp.value)
      }
      return
    })
  }

  const onError = (errors: any, e: any) => console.log(errors, e)
  return (
    <>
      <SimpleContainer maxWidth={'md'}>
        <Breadcrumb routeSegments={[ventasRoutesMap.emisionMasiva]} />

        <StackMenu asideSidebarFixed>
          <Button
            startIcon={<Download />}
            component={Link}
            href={plantillaImportacionMasiva}
            target={'_blank'}
            variant={'outlined'}
            color={'secondary'}
          >
            Descargar Plantilla
          </Button>

          <Button
            startIcon={<Publish />}
            variant={'contained'}
            onClick={form.handleSubmit(onSubmit, onError)}
            autoFocus={false}
          >
            Importar archivo
          </Button>
        </StackMenu>
        <EmisionMasivaForm form={form} />
      </SimpleContainer>
    </>
  )
}

export default EmisionMasiva
